export const FETCH_NEWS = 'FETCH_NEWS'

export const UPDATE_LIST = 'UPDATE_LIST'



// WEBPACK FOOTER //
// ./src/store/news/mutation-types.js